import * as React from 'react';

import NumbersForMac32 from './NumbersForMac32';

export const numbersForMac32 = () => <NumbersForMac32 />;

export default {
    title: 'Icon|Logo|NumbersForMac32',
    component: NumbersForMac32,
    parameters: {
        notes: "`import NumbersForMac32 from 'box-ui-elements/es/icon/logo/NumbersForMac32';`",
    },
};
